import React from 'react'

import IconButtonMaterial from '@mui/material/IconButton'

/**
 * Button Icon
 * @param {object} props
 * @param {function} props.onClick
 * @param {React.Component} props.children
 * @param {string} [props.title]
 * @param {'small'|'medium'|'large'} [props.size='small']
 */
const IconButton = (props) => {
  const { children, onClick = null, size = 'small', title = '' } = props

  return (
    <IconButtonMaterial
      onClick={onClick}
      size={size}
      title={title}
    >
      {children}
    </IconButtonMaterial>
  )
}

export default IconButton